import { FormControl, FormHelperText, RadioGroup } from '@material-ui/core';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';

type Param = {
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number,
    name: string;
    value: any;
    error?: boolean,
    helperText?: any,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
}

const RadioGroupField: React.FC<Param> = ({ id, idGtm, idGtmIndex, children, value, onChange, onBlur, name, error, helperText }) => {

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    return (
        <FormControl error={error} >
            <RadioGroup id={id} aria-label={name} name={name} value={value}
                onChange={onChange} onBlur={onBlur} onFocus={handleOnFocus}
                style={{ flexDirection: 'row' }}>
                {children}
            </RadioGroup>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>);
}

export default RadioGroupField;